/**
 * sessionStorage key set by OktaIntegrationService.signInWithRedirect() right before it hands
 * off to Okta's hosted sign-in page, consumed when the resulting auth-state transition lands.
 *
 * Also read by AnalyticsService's pagehide flush: the full-page redirect round trip fires
 * 'pagehide' with a pending checkout_abandon armed, but it is not an abandonment — the patron
 * is bounced back to the same page afterwards. Shared here (rather than duplicated as a
 * literal) so the writer and the reader cannot drift apart, and so importing it from the
 * Okta service module — which injects AnalyticsService — never creates a module cycle.
 */
export const OKTA_LOGIN_IN_PROGRESS_SESSION_KEY = 'gsOktaLoginInProgress';
